import { useQuery } from '@tanstack/react-query'
import { useTenantStore } from 'src/enviroment/store/tenentStore'
import { client } from '../axios'
import { DEFAULT_TAKE } from 'src/enviroment/constants/constants'

export enum PaymentHistory {
  Get = 'PaymentHistoryGet',
}

export interface PaymentHistoryItem {
  id: string
  amountInCents: number
  status: 'paid' | 'open' | 'void' | 'uncollectible'
  createdAt: string
  invoiceUrl: string
  number: string
}

export interface PaymentHistoryResponse {
  payments: PaymentHistoryItem[]
  hasMore: boolean
}

interface GetPaymentHistoryParams {
  cursorId?: string
  take?: number
}

export function useGetPaymentHistory(params?: GetPaymentHistoryParams) {
  const selectedTenantId = useTenantStore((state) => state.currentTenant?.id)

  return useQuery({
    queryKey: [PaymentHistory.Get, selectedTenantId, params],
    queryFn: async () => {
      const response = await client.get<PaymentHistoryResponse>(`/tenants/${selectedTenantId}/payment-history`, {
        params: {
          cursorId: params?.cursorId,
          take: params?.take ?? DEFAULT_TAKE,
        },
      })
      return response.data
    },
    enabled: Boolean(selectedTenantId),
  })
}
